import React, { Fragment, useRef, useState, useEffect, forwardRef } from "react";
import FormItem from "antd/es/form/FormItem";
import { Col, Row, Spin, message } from 'antd';
import Carousel from 'ReusableComponents/Carousel/Carousel';
import cloneDeep from 'lodash/cloneDeep';

export default forwardRef((props: any, ref: any) => {
  const { form, inputData, language, checkAnswer, } = props,
    { required, questions, defaultValue, id, mediaFiles } = inputData,
    { getFieldDecorator } = form;
  const [images, setImages] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const carouselRef = useRef();

  useEffect(() => {
    if (checkAnswer && carouselRef.current) carouselRef.current.next();
  }, [checkAnswer]);

  useEffect(() => {
    const fetchingImages = [];
    const images = mediaFiles.map((mediaFile) => {
      const image = new Image();
      image.src = mediaFile.src;
      fetchingImages.push(image.decode());
      return image;
    });
    Promise.all(fetchingImages)
    .then(() => setImages(images));
  }, [mediaFiles])

  useEffect(() => {
    if (images) {
      setIsLoading(false);
    }
  }, [images])

  return (
    <FormItem>
      {getFieldDecorator(id, {
        initialValue: defaultValue,
        rules: [
          {
            required,
            message: "Required Field"
          }
        ]
      })(
        <Row type="flex" justify="center" align="middle">
          {
            isLoading ?
            <Spin /> :
            <Carousel ref={carouselRef} animation={"fade"}>
              {
                mediaFiles.map((mediaFile, index) => {
                  return (
                    <Fragment key={index}>
                      <Col style={{ marginBottom: "5vmin" }}>
                        <img
                          style={{ height: '20vmin' }}
                          src={mediaFile.src}
                          alt="picture goes here"
                        />
                      </Col>
                    </Fragment>
                  )
                })
              }
            </Carousel>
          }
        </Row>
      )}
    </FormItem>
  );
});
